import { Spinner } from "../spinner";

export function ModalLoading() {
	/** Render */
	return (
		<div className="flex-center h-[200px]">
			<Spinner />
		</div>
	);
}
